import { useFetcher } from "@remix-run/react";
import { useEffect, useRef, useState } from "react";

export function Newsletter() {
  const inputRef = useRef(null);
  const successRef = useRef(null);
  const mounted = useRef(false);
  const fetcher = useFetcher();
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  //   const success = fetcher.data?.success;
  //   const error = fetcher.data?.success === false;

  const state =
    fetcher.state === "submitting"
      ? "submitting"
      : fetcher.data?.success && fetcher.formAction
      ? "success"
      : fetcher.data?.success === false
      ? "error"
      : "idle";

  useEffect(() => {
    if (state === "error") {
      inputRef.current?.focus();
    }

    if (state === "idle" && mounted.current) {
      inputRef.current?.select();
    }

    if (state === "success") {
      successRef.current?.focus();
      setSubmissionSuccess(true);
    }

    mounted.current = true;
  }, [state, submissionSuccess]);

  // Code for Cloudflare Turnstile
  //   useEffect(() => {
  //     turnstile.ready(function () {
  //       turnstile.render(".example-container", {
  //         sitekey: "2x00000000000000000000AB",
  //         callback: function (token) {
  //           console.log(`Challenge Success ${token}`);
  //         },
  //       });
  //     });
  //   }, []);

  return (
    <div className="bg-violet-100 mt-10 rounded-lg  ">
      <div>
        <div className="flex flex-col mx-auto max-w-xl text-center p-5 min-h-64 justify-around">
          <div className="aria-[hidden=true]:*:hidden flex flex-col gap-3 ">
            <div aria-hidden={submissionSuccess}>
              <div className="text-3xl font-bold leading-snug tracking-tight mb-2">
                Join the Shopdeploy Digest
              </div>
              <div>
                Get Takealot Marketplace tips delivered straight to your inbox
              </div>
            </div>

            <fetcher.Form
              replace
              method="post"
              aria-hidden={submissionSuccess}
              action="/subscribe"
            >
              <fieldset
                disabled={state === "submitting"}
                className="flex flex-col gap-3 disabled:*:opacity-75"
              >
                <input
                  aria-label="Email address"
                  aria-describedby="error-message"
                  ref={inputRef}
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  autoComplete="email"
                  className="rounded-md disabled:opacity-20"
                />
                {/* <div
                    className="example-container"
                    data-sitekey="3x00000000000000000000FF"
                  ></div> */}

                <button
                  type="submit"
                  className="bg-orange-500 py-3 rounded-md font-semibold text-white tracking-wide text-lg"
                >
                  {state === "submitting" ? "Subscribing..." : "Subscribe"}
                </button>
                <p id="error-message" className="text-red-900 leading-tight">
                  {state === "error" && fetcher.data.message}
                </p>
              </fieldset>
            </fetcher.Form>

            <div
              className="flex flex-col gap-5 transition ease-in-out delay-150"
              aria-hidden={!submissionSuccess}
            >
              <h2
                className="font-semibold text-3xl active:outline-none focus:outline-none mb-2"
                ref={successRef}
                tabIndex={-1}
              >
                Thanks!{" "}
              </h2>
              <div className="font-normal text-xl">
                You've been subscribed to the Shopdeploy Digest.
              </div>

              <button
                onClick={() => setSubmissionSuccess(false)}
                className="bg-orange-500 py-3 rounded-md font-semibold text-white tracking-wide text-lg"
              >
                Got It
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
